import { Badge } from "../ui/badge"
import { cn } from "../../lib/utils"

type SLAStatus = "ok" | "warning" | "breach"

interface SLABadgeProps {
  status: SLAStatus
  className?: string
}

const slaConfig: Record<SLAStatus, { label: string; className: string }> = {
  ok: { 
    label: "OK", 
    className: "bg-sla-ok/10 text-sla-ok border-sla-ok/20" 
  },
  warning: { 
    label: "Предупреждение", 
    className: "bg-sla-warning/10 text-sla-warning border-sla-warning/20" 
  },
  breach: { 
    label: "Нарушено", 
    className: "bg-sla-breach/10 text-sla-breach border-sla-breach/20" 
  },
}

export function SLABadge({ status, className }: SLABadgeProps) {
  const config = slaConfig[status]
  return (
    <Badge 
      variant="outline" 
      className={cn("text-xs font-medium border", config.className, className)}
    >
      {config.label}
    </Badge>
  )
}

